import styled from '@emotion/styled'

import Image from '@segment/matcha/components/Image'

import AllYourEventsCentralizedPng2x from './assets/AllYourEventsCentralized@2x.png'
import AllYourEventsCentralizedWebp from './assets/AllYourEventsCentralized.webp'
import AllYourEventsCentralizedWebp2x from './assets/AllYourEventsCentralized@2x.webp'

const AllYourEventsCentralizedImage = () => {
  return (
    <Picture>
      <source type="image/webp" srcSet={`${AllYourEventsCentralizedWebp}, ${AllYourEventsCentralizedWebp2x} 2x`} />
      <StyledImage
        width="640"
        height="524"
        src={AllYourEventsCentralizedPng2x}
        alt="Illustration: Optimized for Cost and Performance"
        loading="lazy"
      />
    </Picture>
  )
}

const Picture = styled.picture`
  filter: drop-shadow(${({ theme }) => theme.shadows[2]});
  max-width: 640px;
`

const StyledImage = styled(Image)`
  object-fit: contain;
`

export default AllYourEventsCentralizedImage
